// @flow
import React from 'react';
import { prettyNumberFormat } from 'app/common/lib/locale';
import { RequestContextConsumer } from 'app/common/react/components/RequestContext';

type Props = {|
  currency?: string,
  maximumFractionDigits?: number,
  minimumFractionDigits?: number,
  shortform?: boolean,
  shortformMaximumFractionDigits?: number,
  formatStyle?: 'decimal' | 'currency' | 'percent',
  uplimit?: number,
  value: number,
|};

const PrettyNumber = ({
  currency,
  maximumFractionDigits,
  minimumFractionDigits,
  shortform,
  shortformMaximumFractionDigits,
  formatStyle,
  uplimit,
  value,
}: Props) => (
  <RequestContextConsumer>
    {(requestContext) =>
      prettyNumberFormat(requestContext.locale, value, {
        currency,
        maximum_fraction_digits: maximumFractionDigits,
        minimum_fraction_digits: minimumFractionDigits,
        shortform,
        shortform_maximum_fraction_digits: shortformMaximumFractionDigits,
        style: formatStyle,
        uplimit,
      })
    }
  </RequestContextConsumer>
);

export default PrettyNumber;
